<div class="modal-header">
  <div class="modal-title">
    <h3>Betriebsauftrag {{ order.id }}-{{ order.index }} starten</h3>
  </div>
</div>

<div class="modal-body">
  <business-order-start-errors [errors]="errors" [errorFetches]="errorFetches"></business-order-start-errors>
</div>
<div class="modal-footer">
  <loading-button [clazz]="'btn btn-success btn-sm pull-right'" (loadingSave)="submit($event)">
    Betriebsauftrag starten
  </loading-button>
</div>
